import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./mobile.css";
import "./features/reports/reports.css";
import "./features/whatsapp/whatsapp.css";
import "./features/notificationTriggers/notificationTriggers.css";

import * as serviceWorker from "./serviceWorker";
import ParentApp from "./ParentApp";

const rootEl = document.getElementById("root");

let render = () => {
  ReactDOM.render(<ParentApp />, rootEl);
};
if (module.hot) {
  module.hot.accept("./app/layout/App", () => {
    setTimeout(render);
  });
}
render();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
